import React, { useContext } from 'react'
import Layout from 'shared/layouts/Main'
import { roles } from 'consts'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import { getAllCustomData } from 'shared/components/App/Auth'
import { ReactReduxContext } from 'react-redux'
import hasAnyRole from 'shared/utils/hasAnyRole'
import LayoutSwitcher from 'components/LayoutSwitcher'

const InactivePage: React.FunctionComponent = () => {

  const { store } = useContext(ReactReduxContext)

  const customerData = getAllCustomData()
  const message = customerData['customer']['inactive_message'] ?? '<p>Your Portal is currently inactive. Please contact your administrator.</p>'
  
  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      pageTitle='Portal Offline'
      menuBottomInsert={hasAnyRole([roles.superAdmin]) ? <LayoutSwitcher store={store} /> : false}
    >
      <div style={{ height: '70vh' }} dangerouslySetInnerHTML={{__html: message}}></div>
    </Layout>
  )
}

export default InactivePage
